import './App.css';
import React, { useEffect,useState } from "react";
import { collection, doc, onSnapshot, getDoc,getFirestore, setDoc } from "firebase/firestore"
import { db } from './firebase-config'
import {onValue,ref,child,get} from "firebase/database"

 export function Chat (props){
  const [messages, setMessages] = useState([])
  
  async function getDocument() {
  if (props.topic){
    console.log(props.topic)
  const docRef = doc(db,'topics',props.topic);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const ms= docSnap.data().message
    setMessages([])
    if(ms){
    ms.forEach(m=>{
      setMessages((current)=>{
        return [...current,m]
      })
    })
  }
  } else {
    // doc.data() will be undefined in this case
    console.log("No such document!");
  }
}
}
  useEffect(()=>{
  getDocument()
  
  }
   ,[props.topic])

   useEffect(() => {
    const getMessages = () => {
      const unsub = onSnapshot(doc(db, "topics", props.topic), (doc) => {
        if (doc.data()){
        setMessages(doc.data().message)
        }
        else{
          setMessages([])
        }
      });

      return () => {
        unsub();
      };
    };

    props.topic && getMessages();
  }, [props.topic]);
  if (!messages){
    return (
      <div className='chat'>
            <h1 className='title'>{'#'+props.topic}</h1>      
      </div>
    )
  }
  return (
        <div className='chat'>
            <h1 className='title'>{'#'+props.topic}</h1>
            {
            messages.map((m,i)=>{
            const date = new Date(m.time.seconds *1000)
            const year = date.getFullYear()
            const month = date.getMonth()
            const day = date.getDay()
            const hour = date.getHours();
            let minute = date.getMinutes();
            if ((minute.toString().length==1)){
              minute = `0${minute.toString()}`
            }
            return(
            <div className='message' key={i}>    
            <div className='user-div'>
            <img className='avatar' alt='avatar' src={m.avatar}/>
            <div className='nameTime'>
              <h3 className='user-name'>{m.usernaem}</h3>
              <div className='time-div'>
              <p className='time'>{year} {month}/{day}</p>
              <p className='time right'>{hour}:{minute}</p>
              </div>
            </div>
            </div>
            <div className='message-content'>
              <p>{m.message}</p>
          </div>
        </div>)
        
            }
        )}
        </div>
     )
    }
  